import { render } from "./JobJobBoardsAd.vue?vue&type=template&id=45376707"
import script from "./JobJobBoardsAd.vue?vue&type=script&lang=js"
export * from "./JobJobBoardsAd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__